import { NgModule, Optional, SkipSelf } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../shared/shared.module'
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor'
import { GlobalHttpInterceptor } from './interceptors/global-http.interceptor'
import { TrimInterceptor } from './interceptors/trim.interceptor'

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule, SharedModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrimInterceptor,
      multi: true
    },

    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(
        `${parentModule} has already been loaded. Import Core module in the AppModule only.`
      )
    }
  }
}
